import { eduIDApi } from "./common";
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["OK"] = "ok";
    ActionStatus["NOT_FOUND"] = "not-found";
    ActionStatus["CONSUMED"] = "consumed";
    ActionStatus["STALE"] = "stale";
    ActionStatus["WRONG_ACCR"] = "wrong-accr";
    ActionStatus["NO_MFA"] = "no-mfa";
    ActionStatus["CREDENTIAL_NOT_RECENTLY_USED"] = "credential-not-recently-used";
})(ActionStatus || (ActionStatus = {}));
export const securityApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        updateOfficialUserData: builder.query({
            query: () => ({
                url: "refresh-official-user-data",
                body: {},
            }),
            extraOptions: { service: "security" },
        }),
        postDeleteAccount: builder.query({
            query: () => ({
                url: "terminate-account",
                body: {},
            }),
            extraOptions: { service: "security" },
        }),
        removeWebauthnToken: builder.query({
            query: (body) => ({
                url: "webauthn/remove",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        requestCredentials: builder.query({
            query: () => ({
                url: "credentials",
            }),
            extraOptions: { service: "security" },
        }),
        registerWebauthn: builder.query({
            query: (body) => ({
                url: "webauthn/register/complete",
                body: {
                    response: body.webauthn_attestation,
                    description: body.description,
                },
            }),
            extraOptions: { service: "security" },
        }),
        beginRegisterWebauthn: builder.query({
            query: (body) => ({
                url: "webauthn/register/begin",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        fetchSuggestedPassword: builder.query({
            query: () => ({
                url: "change-password/suggested-password",
            }),
            extraOptions: { service: "security" },
        }),
        changePassword: builder.query({
            query: (body) => ({
                url: "change-password/set-password",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        addNin: builder.query({
            query: (body) => ({
                url: "add-nin",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        removeNin: builder.query({
            query: (body) => ({
                url: "remove-nin",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        fetchApprovedSecurityKeys: builder.query({
            query: () => ({
                url: "webauthn/approved-security-keys",
            }),
            extraOptions: { service: "security" },
        }),
        removeIdentity: builder.query({
            query: (body) => ({
                url: "remove-identity",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        getAuthnStatus: builder.query({
            query: (body) => ({
                url: "authn-status",
                body,
            }),
            extraOptions: { service: "security" },
        }),
        checkAuthnStatus: builder.query({
            query: () => ({
                url: "authn-status",
            }),
            extraOptions: { service: "security" },
        }),
    }),
});
export default securityApi;
